import { render } from "./VerticalFeedCreate.vue?vue&type=template&id=e8bba3c4"
import script from "./VerticalFeedCreate.vue?vue&type=script&lang=js"
export * from "./VerticalFeedCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__